import axios from '@/plugins/axios'

export default {
  namespaced: true,

  state: {
    loading: false,
    allContracts: [],
    allDistroContracts: [],
    page: 1,
    page_size: 10,
    order_column: 'created_at',
    order_type: 'desc'
  },

  mutations: {
    setContracts(state, payload) {
      state.allContracts = payload
    },
    setDistroContracts(state, payload) {
      state.allDistroContracts = payload
    },
    setPage(state, payload) {
      state.page = payload
    },
    setPageSize(state, payload) {
      state.page_size = payload
    },
    setOrdering(state, payload) {
      state.order_column = payload.column
      state.order_type = payload.type
    },
    setLoading(state, payload) {
      state.loading = payload
    }
  },

  actions: {
    read({ commit, state }, type) {
      commit('setLoading', true)
      axios.admin
        .get('cms/contracts', {
          params: {
            type:type,
            page: state.page,
            page_size: state.page_size,
            order_column: state.order_column,
            order_type: state.order_type
          }
        })
        .then(r => {
          const contracts = type === 2 ? 'setContracts' : 'setDistroContracts';
          commit(contracts, r.data.data);
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },

    getContract({ state }, { id, type }) {
      const contractType = type === 2 ? 'cid' : 'distro';
      const filename = `${contractType}_contract_${id}.pdf`;

      axios.admin
          .get(`contracts/${type === 2 ? '' : 'distro/'}${id}`, {
            responseType: 'blob'
          })
          .then(r => {
            const url = window.URL.createObjectURL(new Blob([r.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
          })
          .catch(e => {
            console.log(e);
          });
    },

    getCidContract({ state }, id) {
      axios.admin
          .get('contracts/'+id, {
            responseType: 'blob'
          })
          .then(r => {
            const url = window.URL.createObjectURL(new Blob([r.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'cid_contract_'+id+'.pdf')
            document.body.appendChild(link)
            link.click()
          })
          .catch(e => {
            console.log(e)
          })
    },
    getDistroContract({ state }, id) {
      axios.admin
          .get('contracts/distro/'+id, {
            responseType: 'blob'
          })
          .then(r => {
            const url = window.URL.createObjectURL(new Blob([r.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'distro_contract_'+id+'.pdf')
            document.body.appendChild(link)
            link.click()
          })
          .catch(e => {
            console.log(e)
          })
    },
    deleteContract({ dispatch }, { id, type }) {
      axios.admin.put(`cms/contracts/delete/${id}`).then(() => {
        dispatch('read', type);
      });
    }
  }
}
